import { render, staticRenderFns } from "./RedirectAlert.vue?vue&type=template&id=60eae29e&scoped=true"
import script from "./RedirectAlert.vue?vue&type=script&lang=js"
export * from "./RedirectAlert.vue?vue&type=script&lang=js"
import style0 from "./RedirectAlert.vue?vue&type=style&index=0&id=60eae29e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eae29e",
  null
  
)

export default component.exports